import React from 'react';
import { Sparkles } from 'lucide-react';

export function LoadingScreen({ label = 'Loading…' }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex items-center gap-3 text-muted-foreground">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground animate-pulse">
          <Sparkles className="h-5 w-5" />
        </div>
        <div className="text-sm">{label}</div>
      </div>
    </div>
  );
}
